import _toConsumableArray from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _createForOfIteratorHelper from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import { getMerchantChannelList } from '@/services/labelingManagement';
import { getTransport } from '@/services/productDetail';
import { getDeliveryArea, getCarriage, putCarriage, putCarriageStatus, getDeliveryEnableArea } from '@/services/freightsetting';
import { toThousandslsFilter } from "@/filters/";
export default {
  name: 'freightsetting',
  i18n: require('./i18n-freightsetting.js'),
  filters: {
    moneyNumFormat: function moneyNumFormat(num) {
      return num;
    }
  },
  components: {},
  data: function data() {
    return {
      //缓存变量值
      cacheData: [],
      //页标签用
      activeKeyForSendWayList: 1,
      activeKeyForReceiveAddressList: 1,
      //发货渠道(接口返回)
      sendWayList: [],
      //收货地(接口返回)
      receiveAddressList: [],
      //定义列
      columns: [{
        title: this.$t('freightsetting.japanaddress'),
        dataIndex: 'regionName',
        scopedSlots: {
          customRender: 'regionName'
        },
        width: "200px"
      }, {
        title: this.$t('public.status'),
        dataIndex: 'status',
        scopedSlots: {
          customRender: 'status'
        },
        width: "100px"
      }, {
        title: this.$t('freightsetting.sendDay'),
        dataIndex: 'transportDay',
        scopedSlots: {
          customRender: 'transportDay'
        },
        align: 'right',
        width: "120px"
      },
      // 		 {
      // 			title: this.$t('freightsetting.sendRules'),
      // 			dataIndex: '',
      // 			scopedSlots: {
      // 				customRender: 'sendRules'
      //   },
      //   className: "mergeCol",
      //   width: "120px"
      // }, {
      //   title: this.$t('freightsetting.sendmoney'),
      //   dataIndex: 'freight',
      //   scopedSlots: {
      //     customRender: 'freight'
      //   },
      //   className: "mergeCol",
      //   width: "200px"
      // }, 
      {
        title: this.$t('public.operation'),
        dataIndex: 'operation',
        scopedSlots: {
          customRender: 'operation'
        }
      }],
      //表格(接口返回)
      tableDataList: [],
      isTableLoading: false,
      //编辑状态
      editingKey: '',
      //区域
      areaArray: [],
      //温度区分
      transportArray: [],
      editLoading: false,
      deliveryChannel: 1
    };
  },
  computed: {
    cacheDataStr: function cacheDataStr() {
      return JSON.stringify(this.cacheData);
    }
  },
  watch: {
    cacheDataStr: function cacheDataStr(val, oldValue) {
      var self = this;
      var cacheDataClone = _.cloneDeep(self.cacheData);
      if (cacheDataClone.id) {
        var _iterator = _createForOfIteratorHelper(self.transportArray),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var transport = _step.value;
            if (!cacheDataClone.transportFeeList[transport.id]) {
              cacheDataClone.transportFreeList[transport.id] = 0;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        self.cacheData = cacheDataClone;
      }
    }
  },
  mounted: function mounted() {},
  created: function created() {
    //区分运营方式
    this.deliveryChannel = localStorage.getItem('deliveryChannel');
    //做缓存
    // this.cacheData = JSON.parse(JSON.stringify(this.tableDataList));
    this.loadSendWayList();
    this.loadSendTypeList();
    this.loadDeliveryArea();
  },
  methods: {
    formatMoney: function formatMoney(num) {
      num = num || 0;
      return localStorage.leftCurrencySymbol + toThousandslsFilter(num) + localStorage.rightCurrencySymbol;
    },
    //切换渠道事件
    changeSendWay: function changeSendWay() {
      this.cacheData = {};
      this.editingKey = "";
      this.loadFreight(this.activeKeyForSendWayList);
    },
    //动态列合并行上
    handleChange1: function handleChange1(value, column, column1) {
      if (this.cacheData && this.editingKey) {
        if (column1) {
          if (this.cacheData[column]) {
            this.cacheData[column][column1] = {};
            this.cacheData[column][column1] = value;
          } else {
            this.cacheData[column] = {};
            this.cacheData[column][column1] = value;
          }
        } else {
          this.cacheData[column] = value;
        }
      }
    },
    //编辑
    edit: function edit(id) {
      var newData = _toConsumableArray(this.tableDataList);
      console.log(this.tableDataList, 'list............');
      var target = newData.filter(function (item) {
        return id == item.id;
      })[0];
      this.editingKey = id;
      if (target) {
        target.editable = true;
        this.cacheData = JSON.parse(JSON.stringify(target));
        this.tableDataList = newData;
      }
      this.editLoading = false;
    },
    //保存
    save: function save(id) {
      var _this = this;
      if ((this.cacheData.id + "").indexOf("|_|") != -1) {
        this.cacheData.id = "";
      }
      // let error = false;
      // for(let item of Object.values(this.cacheData["transportFeeList"])){
      // 	if(item <= 0){
      // 		error = true
      // 	}
      // }
      // if(error){
      // 	this.$message.error(this.$t("freightsetting.sendmoneyNoNull"));
      // 	return;
      // }
      if (!this.editLoading) {
        this.editLoading = true;
        putCarriage(this.cacheData).then(function (res) {
          if (res.data.code == 200) {
            _this.cacheData = {};
            _this.editingKey = '';
            var newData = _toConsumableArray(_this.tableDataList);
            var target = newData.filter(function (item) {
              return id == item.id;
            })[0];
            if (target) {
              delete target.editable;
            }
            _this.$message.success(_this.$t('public.updateSuccessfully'));
            _this.loadFreight(_this.deliveryChannel == 1 ? _this.activeKeyForSendWayList : 0);
            _this.cacheData = {};
          } else {
            _this.editLoading = false;
          }
        }).finally(function () {
          _this.editLoading = false;
        });
      }
    },
    //取消
    cancel: function cancel(id) {
      var newData = _toConsumableArray(this.tableDataList);
      var target = newData.filter(function (item) {
        return id == item.id;
      })[0];
      this.editingKey = '';
      if (target) {
        this.cacheData = {};
        delete target.editable;
        this.tableDataList = newData;
      }
    },
    //更新成功
    confirmGengXin: function confirmGengXin(row, status) {
      var _this2 = this;
      if (row.putCarriageStatusLoading) return;
      row.putCarriageStatusLoading = true;
      putCarriageStatus({
        channelId: 0,
        areaIds: row.areaId,
        status: status
      }).then(function (res) {
        if (res.data.code == 200) {
          _this2.$message.success(_this2.$t('public.updateSuccessfully'));
          _this2.loadFreight(_this2.deliveryChannel == 1 ? _this2.activeKeyForSendWayList : 0);
        }
      }).finally(function () {
        row.putCarriageStatusLoading = false;
      });
    },
    //导入成功
    confirmDaoRu: function confirmDaoRu(e) {
      this.$message.success(this.$t('freightsetting.importOk'));
    },
    //加载渠道列表
    loadSendWayList: function loadSendWayList() {
      var _this3 = this;
      getMerchantChannelList({
        statusType: 1
      }).then(function (res) {
        if (res.data.code == 200) {
          _this3.sendWayList = res.data.data;
          if (_this3.sendWayList.length > 0) {
            _this3.loadFreight(_this3.deliveryChannel == 1 ? _this3.activeKeyForSendWayList : 0);
          }
        }
      });
    },
    //加载温度区分
    loadSendTypeList: function loadSendTypeList() {
      var _this4 = this;
      getTransport({
        statusType: 2
      }).then(function (res) {
        if (res.data.code == 200) {
          _this4.transportArray = res.data.data;
          _this4.tempTransportArray = {};
          for (var key in _this4.transportArray) {
            var item = _this4.transportArray[key];
            _this4.tempTransportArray[item.id] = 0;
          }
        }
      });
    },
    //加载区域
    loadDeliveryArea: function loadDeliveryArea() {
      var _this5 = this;
      getDeliveryEnableArea().then(function (res) {
        if (res.data.code == 200) {
          _this5.areaArray = res.data.data[0].regionList;
          console.log(_this5.areaArray, '3333');
          _this5.loadFreight(_this5.deliveryChannel == 1 ? _this5.activeKeyForSendWayList : 0);
        }
      });
    },
    //加载运费
    loadFreight: function loadFreight(channelId) {
      var _this6 = this;
      getCarriage({
        channelId: channelId
      }).then(function (res) {
        if (res.data.code == 200) {
          var temp = [];
          console.log(res.data.data, '12465798');
          for (var key in res.data.data) {
            var item = res.data.data[key];
            temp["freight_" + item.areaId] = item;
          }
          _this6.freightList = temp;
          console.log(channelId, _this6.freightList, '777');
          _this6.splicingData(channelId);
        }
      });
    },
    splicingData: function splicingData(channelId) {
      var temp = [];
      for (var key in this.areaArray) {
        var item = this.areaArray[key];
        var obj = this.freightList['freight_' + item.regionId] || {
          areaId: item.regionId,
          channelId: channelId,
          transportFreeList: JSON.parse(JSON.stringify(this.tempTransportArray)),
          transportFeeList: JSON.parse(JSON.stringify(this.tempTransportArray)),
          transportDay: 0,
          id: item.regionId + '|_|' + channelId + new Date().getTime().toString(36) + Math.random().toString(36).slice(2)
        };
        console.log(obj, '44444444444');
        var tempObj = Object.assign(obj, item);
        temp.push(tempObj);
      }
      this.tableDataList = temp;
      console.log(this.tableDataList, '22222222222');
    }
  }
};